import { SPView, PCView } from "components/common/MediaQuery";
import React, { useState } from "react";

import StreamingActionAreaV2Goods from "./StreamingActionAreaV2Goods";
import StreamingBottomAreaCommentForSP from "./StreamingBottomAreaCommentForSP";
import StreamingSummaryColumn from "./StreamingSummaryColumn";

import type { ActionAreaType } from "./useActionAreaType";
import type { Timestamp } from "@google-cloud/firestore";
import type { THEOPlayer } from "@spwn/types/external/external";
import type { StreamingType } from "@spwn/types/spwn/spwn";
import type { CommentFilterType } from "modules/streaming";
import type { EventInfo } from "utility";

type Props = {
  mainVideoId: string;
  currentVideoId: string;
  eventInfo: EventInfo;
  streamingType: StreamingType;
  isOpenAnnouncement: boolean;
  player: THEOPlayer;
  eventStart: Timestamp;
  THEOPlayerElementHeight: number;
  selectedCommentFilter: CommentFilterType;
  actionAreaType: ActionAreaType;
  hasDvrStartTime: boolean;
  isEditingAnnouncement: boolean;
  streamingAnnouncement: string;
  isLiveCommerceEnabled: boolean;
  isLiveEventEnabled: boolean;
  isOpenLiveEvent: boolean;
  handleToggleLiveEvent: () => void;
  setWatchVideo: (vid: string) => void;
  setIsEditingAnnouncement: (isEditing: boolean) => void;
  setStreamingAnnouncement: (announcement: string) => void;
  handleToggleAnnouncement: () => void;
  handleClickCommentNavigation: () => void;
  handleClickGoodsNavigation: () => void;
  handleChangeCommentFilter: (filter: CommentFilterType) => void;
};

const StreamingBottomArea: React.FC<Props> = (props) => {
  //SP表示の場合はこのstateで表示エリアを切り替える
  const [bottomAreaType, setBottomAreaType] =
    useState<BottomAreaType>("summary");
  return (
    <React.Fragment>
      <PCView>
        <StreamingSummaryColumn
          mainVideoId={props.mainVideoId}
          currentVideoId={props.currentVideoId}
          eventInfo={props.eventInfo}
          streamingType={props.streamingType}
          isOpenAnnouncement={props.isOpenAnnouncement}
          isEditingAnnouncement={props.isEditingAnnouncement}
          streamingAnnouncement={props.streamingAnnouncement}
          isLiveCommerceEnabled={props.isLiveCommerceEnabled}
          isLiveEventEnabled={props.isLiveEventEnabled}
          isOpenLiveEvent={props.isOpenLiveEvent}
          handleToggleLiveEvent={props.handleToggleLiveEvent}
          setWatchVideo={props.setWatchVideo}
          setIsEditingAnnouncement={props.setIsEditingAnnouncement}
          setStreamingAnnouncement={props.setStreamingAnnouncement}
          handleToggleAnnouncement={props.handleToggleAnnouncement}
          handleClickCommentNavigation={props.handleClickCommentNavigation}
          handleClickGoodsNavigation={props.handleClickGoodsNavigation}
        />
      </PCView>
      <SPView>
        {bottomAreaType === "comment" &&
          props.eventInfo.isHiddenStreamingComment === false && (
            <StreamingBottomAreaCommentForSP
              player={props.player}
              eventStart={props.eventStart}
              eventInfo={props.eventInfo}
              mainVideoId={props.mainVideoId}
              THEOPlayerElementHeight={props.THEOPlayerElementHeight}
              isOpenAnnouncement={props.isOpenAnnouncement}
              handleToggleAnnouncement={props.handleToggleAnnouncement}
              isEditingAnnouncement={props.isEditingAnnouncement}
              setIsEditingAnnouncement={props.setIsEditingAnnouncement}
              streamingAnnouncement={props.streamingAnnouncement}
              setStreamingAnnouncement={props.setStreamingAnnouncement}
              isOpenLiveEvent={props.isOpenLiveEvent}
              handleToggleLiveEvent={props.handleToggleLiveEvent}
              actionAreaType={props.actionAreaType}
              selectedCommentFilter={props.selectedCommentFilter}
              handleChangeCommentFilter={props.handleChangeCommentFilter}
              handleCloseActionArea={() => setBottomAreaType("summary")}
              hasDvrStartTime={props.hasDvrStartTime}
              isLiveEventEnabled={props.isLiveEventEnabled}
            />
          )}
        {bottomAreaType === "goods" && (
          <StreamingActionAreaV2Goods
            eventInfo={props.eventInfo}
            mainVideoId={props.mainVideoId}
            THEOPlayerElementHeight={props.THEOPlayerElementHeight}
            isOpenAnnouncement={props.isOpenAnnouncement}
            isEditingAnnouncement={props.isEditingAnnouncement}
            selectedCommentFilter={props.selectedCommentFilter}
            streamingAnnouncement={props.streamingAnnouncement}
            setIsEditingAnnouncement={props.setIsEditingAnnouncement}
            setStreamingAnnouncement={props.setStreamingAnnouncement}
            handleToggleAnnouncement={props.handleToggleAnnouncement}
            handleChangeCommentFilter={props.handleChangeCommentFilter}
            handleCloseActionArea={() => setBottomAreaType("summary")}
            isLiveEventEnabled={props.isLiveEventEnabled}
            isOpenLiveEvent={props.isOpenLiveEvent}
            handleToggleLiveEvent={props.handleToggleLiveEvent}
          />
        )}
        {bottomAreaType === "summary" && (
          <StreamingSummaryColumn
            mainVideoId={props.mainVideoId}
            currentVideoId={props.currentVideoId}
            eventInfo={props.eventInfo}
            streamingType={props.streamingType}
            isOpenAnnouncement={props.isOpenAnnouncement}
            isEditingAnnouncement={props.isEditingAnnouncement}
            streamingAnnouncement={props.streamingAnnouncement}
            isLiveCommerceEnabled={props.isLiveCommerceEnabled}
            isLiveEventEnabled={props.isLiveEventEnabled}
            isOpenLiveEvent={props.isOpenLiveEvent}
            handleToggleLiveEvent={props.handleToggleLiveEvent}
            setWatchVideo={props.setWatchVideo}
            setIsEditingAnnouncement={props.setIsEditingAnnouncement}
            setStreamingAnnouncement={props.setStreamingAnnouncement}
            handleToggleAnnouncement={props.handleToggleAnnouncement}
            handleClickCommentNavigation={() => setBottomAreaType("comment")}
            handleClickGoodsNavigation={() => setBottomAreaType("goods")}
          />
        )}
      </SPView>
    </React.Fragment>
  );
};

type BottomAreaType = "comment" | "goods" | "summary";

export default StreamingBottomArea;
